import { createSlice } from '@reduxjs/toolkit';
import {
  createPfPolicy,
  fetchAllPfPolicies,
  fetchPfPolicyById,
  updatePfPolicy,
  deletePfPolicy
} from './pfPolicyActions';
import { PfPolicyState } from './pfPolicyTypes';

const initialState: PfPolicyState = {
  records: [],
  selectedRecord: undefined,
  loadingStates: {
    create: false,
    fetchAll: false,
    fetchById: false,
    update: false,
    delete: false
  },
  errors: {}
};

const pfPolicySlice = createSlice({
  name: 'pfPolicy',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create
      .addCase(createPfPolicy.pending, (state) => {
        state.loadingStates.create = true;
        state.errors.create = undefined;
      })
      .addCase(createPfPolicy.fulfilled, (state, action) => {
        state.loadingStates.create = false;
        state.records.push(action.payload.data);
      })
      .addCase(createPfPolicy.rejected, (state, action) => {
        state.loadingStates.create = false;
        state.errors.create = action.payload as string;
      })

      // Get All
      .addCase(fetchAllPfPolicies.pending, (state) => {
        state.loadingStates.fetchAll = true;
        state.errors.fetchAll = undefined;
      })
      .addCase(fetchAllPfPolicies.fulfilled, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.records = action.payload.data;
      })
      .addCase(fetchAllPfPolicies.rejected, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.errors.fetchAll = action.payload as string;
      })

      // Get By ID
      .addCase(fetchPfPolicyById.pending, (state) => {
        state.loadingStates.fetchById = true;
        state.errors.fetchById = undefined;
      })
      .addCase(fetchPfPolicyById.fulfilled, (state, action) => {
        state.loadingStates.fetchById = false;
        state.selectedRecord = action.payload;
      })
      .addCase(fetchPfPolicyById.rejected, (state, action) => {
        state.loadingStates.fetchById = false;
        state.errors.fetchById = action.payload as string;
      })

      // Update
      .addCase(updatePfPolicy.pending, (state) => {
        state.loadingStates.update = true;
        state.errors.update = undefined;
      })
      .addCase(updatePfPolicy.fulfilled, (state, action) => {
        state.loadingStates.update = false;
        const index = state.records.findIndex(p => p.pfPolicyId === action.payload.id);
        if (index !== -1) {
          state.records[index] = { ...action.payload.data, pfPolicyId: action.payload.id };
        }
      })
      .addCase(updatePfPolicy.rejected, (state, action) => {
        state.loadingStates.update = false;
        state.errors.update = action.payload as string;
      })

      // Delete
      .addCase(deletePfPolicy.pending, (state) => {
        state.loadingStates.delete = true;
        state.errors.delete = undefined;
      })
      .addCase(deletePfPolicy.fulfilled, (state, action) => {
        state.loadingStates.delete = false;
        state.records = state.records.filter(p => p.pfPolicyId !== action.payload);
      })
      .addCase(deletePfPolicy.rejected, (state, action) => {
        state.loadingStates.delete = false;
        state.errors.delete = action.payload as string;
      });
  }
});

export default pfPolicySlice.reducer;
